module.exports = __webpack_public_path__ + "img/CustomerResponseMap_lg.c6fa7575.png";